import styled from "styled-components";

import { getSizeInPx } from "../../methods/common";
import { ShimmerProps } from "./Shimmer.types";

export const StyledShimmer = styled.div<Partial<ShimmerProps>>`
    width: 100%;
    height: ${({ height }) => getSizeInPx(height) ?? "auto"};
    min-height: ${({ minHeight }) => getSizeInPx(minHeight) ?? "120px"};
    border-radius: ${({ borderRadius }) => getSizeInPx(borderRadius) ?? "16px"};
    background: linear-gradient(90deg, #eef2ff 25%, #e0e7ff 50%, #eef2ff 75%);
    background-size: 200% 100%;
    animation: shimmer 1.2s infinite;

    @keyframes shimmer {
        0% {
            background-position: 200% 0;
        }
        100% {
            background-position: -200% 0;
        }
    }
`;
